import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import ImportModalForm from './ImportModalForm';

const ImportBankingModal = ({ open, toggle, getData }) => {
  const DialogWrapper = styled(Dialog)(
    () => `
              .MuiDialog-container {
                  height: 100vh;
              }
              
              .MuiDialog-paperScrollPaper {
                  max-height: calc(100vh - 80px)
              }
          `
  );
  return (
    <DialogWrapper
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <ImportModalForm toggle={toggle} getData={getData} />
    </DialogWrapper>
  );
};

export default ImportBankingModal;
